import { render, staticRenderFns } from "./ScannedHealth.vue?vue&type=template&id=863939a0&scoped=true&"
import script from "./ScannedHealth.vue?vue&type=script&lang=js&"
export * from "./ScannedHealth.vue?vue&type=script&lang=js&"
import style0 from "./ScannedHealth.vue?vue&type=style&index=0&id=863939a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "863939a0",
  null
  
)

export default component.exports